import {
  type IconButtonProps,
  IconButton as MuiIconButton,
} from '@mui/material';
import { useStyles } from 'tss-react';

interface Props extends IconButtonProps {
  variant?: 'primary' | 'secondary' | 'tertiary' | 'ghost' | 'inline';
}

export default function IconButton(props: Props) {
  const { cx } = useStyles();

  return (
    <MuiIconButton
      {...props}
      className={cx(
        props.className,
        `MuiIconButton-${props.variant ?? 'primary'}`
      )}
    >
      <span
        className='MuiButton-icon'
        style={{ opacity: props.loading ? 0 : 1 }}
      >
        {props.children}
      </span>
    </MuiIconButton>
  );
}
